export default "__VITE_ASSET__vfEPAMr$__"